import { Decorable } from './../types/decorable';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export const ParsePathParams = (root: string, route: ActivatedRoute) => {
  const segments = route.url as BehaviorSubject<Array<UrlSegment>>;
  const params: Decorable = {};
  const rootPaths = root.split('/');
  if (segments?.value?.length > rootPaths.length) {
    const paramSegments = segments.value.slice(rootPaths.length);
    for (const paramSeg of paramSegments) {
      if (paramSeg.path.indexOf(':') > -1) {
        let [key, val] = paramSeg.path.split(':');
        val = decodeURI(val);
        if (val.indexOf('?') > -1) {
          let parts = val.split('?');
          val = parts.shift();
          const queryString = parts.join('?');
          queryString.split('&').every((queryPart)=>{
            const queryParamInfo = queryPart.split('=');
            const queryKey = queryParamInfo.shift();
            if(queryParamInfo.length > 0) {
              if(queryParamInfo.length === 1) {
                params[queryKey] = queryParamInfo.shift();
              } else {
                params[queryKey] = queryParamInfo;
              }
            } else {
              params[queryKey] = true;
            }
            if (['true', 't'].indexOf(params[queryKey] ) > -1) {
              params[queryKey] = true;
            } else if (['false', 'f'].indexOf(params[queryKey] ) > -1) {
              params[queryKey]  = false;
            }
            return true;
          })

        }
        if (['true', 't'].indexOf(val) > -1) {
          params[key] = true;
        } else if (['false', 'f'].indexOf(val) > -1) {
          params[key] = false;
        } else {
          params[key] = val;
        }
      } else {
        if (isNaN(Number(paramSeg.path))) {
          if (paramSeg.path.indexOf('!') === 0) {
            params[paramSeg.path.substring(1)] = false;
          } else {
            params[paramSeg.path] = true;
          }
        } else {
          break;
        }
      }

    }
    return params;
  }

}
